// @ts-ignore
process.turbopack = {}
